// @ts-ignore
process.turbopack = {}
